import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataServiceService } from '../services/data-service.service';
import { UtilsService } from '../services/utils.service';
import { TextTransformPipe } from "../text-transform.pipe";

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, TextTransformPipe],
  styleUrls: ['./new-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewHeaderComponent implements OnInit {
  @Input() stateList: any[] = []; // Allow passing states from parent
  public isEnable = false;
  public isOffplanSubMenu = false;
  public isBuildSubMenu = false;

  enableMenu(event: any) {
    event.preventDefault();
    this.isEnable = !this.isEnable;
  }

  closeMenu(): void {
    this.isEnable = false;
    this.isOffplanSubMenu = false;
    this.isBuildSubMenu = false;
  }

  toggleOffplanMenu(): void {
    this.isOffplanSubMenu = !this.isOffplanSubMenu;
    this.isBuildSubMenu = false;
  }

  toggleBuildMenu(): void {
    this.isBuildSubMenu = !this.isBuildSubMenu;
    this.isOffplanSubMenu = false;
  }

  constructor(
    public dataService: DataServiceService,
    public cdr: ChangeDetectorRef,
    public utilsService: UtilsService,
    public modalService: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.stateList.length === 0 && this.utilsService.isBrowser) {
      this.dataService.getStates().subscribe({
        next: (result: any) => {
          if (result && result.data && Array.isArray(result.data)) {
            result.data = result.data.map((data: any) => ({
              ...data,
              Country: data.country?.name
            }));
            this.stateList = result.data || [];
          } else {
            this.stateList = []; // Fallback
          }
          this.cdr.detectChanges();
        },
        error: () => {
          // Keep the static "All Projects" link usable if the optional state list is unavailable.
          this.stateList = [];
        }
      });
    }
  }
}
